import React, { createContext, useState } from 'react'
export let DataList = createContext([]);
export default function Datalist({children}) {
    let [Data,setData] = useState([]);
    let values = {Data,setData}
  return (
    <DataList.Provider value={values}>
        {children}
    </DataList.Provider>
  )
}
